import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector
} from 'react-redux'
import { type TypedUseSelectorHook, shallowEqual } from 'react-redux'
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist'
import authReducer from './AuthContext/authSlice'
import { homeContext } from './HomeContext/homeSlice'
import salesOrderReducer from './SalesOrderContext/salesOrderSlice'
import { productContext } from './ProductContext'
import { ovContext } from './OVContext'
import { structuralContext } from './StructuralContext'
import { negotiationsContext } from './NegotiationsContext/negotiationsSlice'
import { inventoryContext } from './InventoryContext/inventorySlice'
import { extraVolumeContext } from './ExtraVolumeContext/ExtraVolumeSlice'
import { managementContext } from './ManagementContext/managementSlice'
import { backofficeContext } from './BackofficeContext/backofficeSlice'
import { batchOrderContext } from './BatchOrderContext/BatchOrderSlice'
import { sharedContext } from './SharedContext/sharedSlice'

const persisteProduct = persistReducer(
  {
    key: 'product',
    storage
  },
  productContext
)
const persistSalesOrder = persistReducer(
  {
    key: 'salesOrder',
    storage
  },
  salesOrderReducer
)
export const store = configureStore({
  reducer: {
    auth: authReducer,
    home: homeContext,
    salesOrder: persistSalesOrder,
    products: persisteProduct,
    ov: ovContext,
    structure: structuralContext,
    negotiations: negotiationsContext,
    inventory: inventoryContext,
    extraVolume: extraVolumeContext,
    management: managementContext,
    backoffice: backofficeContext,
    batchOrder: batchOrderContext,
    shared: sharedContext
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }),

  devTools: process.env.NODE_ENV !== 'production'
})

export const persistor = persistStore(store)

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector

export const useDispatch = () => useReduxDispatch<AppDispatch>()

export { shallowEqual }
